<ng-container>
  <router-outlet></router-outlet>
</ng-container>

<app-version-badge></app-version-badge>



<ngx-spinner
  bdColor="#ffffff8c"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">

<div class="loader"></div>
</ngx-spinner>